import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters } from "../../api/Log"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, CheckIcon, SearchIcon, CalendarIcon, TableIcon, FilterIcon, InfoIcon } from "./LogIcons"

/* Timezone — диапазоны строим в ВЫБРАННОЙ зоне, не в зоне машины */
import { nowInTz } from "../../helpers/timezone"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF TABLES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8


/* Widget Log Filter */
class LogFilter extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            selected: "all",
            start: null,
            end: null,
            tables: [],
            type: "",
            allTables: [],
            allTypes: [],
            search: "",
        }
    }

    /* Periods Of The Picker */
    getPeriods = () => [
        { key: "3hours", text: t("player.last3h") },
        { key: "6hours", text: t("player.last6h") },
        { key: "12hours", text: t("player.last12h") },
        { key: "today", text: t("player.today") },
        { key: "yesterday", text: t("player.yesterday") },
        { key: "7days", text: t("player.last7days") },
        { key: "14days", text: t("player.last14days") },
        { key: "30days", text: t("player.last30days") },
        { key: "month", text: t("player.thisMonth") },
        { key: "prevmonth", text: t("player.prevMonth") },
        { key: "all", text: t("player.allTime") },
    ]

    /* Open Action */
    open = ({ selected = "all", start = null, end = null, tables = [], type = "" }) => {

        this.setState({
            visible: true,
            selected,
            start,
            end,
            type,
            tables: [...tables],
            search: "",
        }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action — the tables and the types are built from the logs themselves,
     * so no option of the filter can ever lead to an empty list */
    load = () => {

        /* Check Loaded */
        if (this.state.allTables.length > 0 || this.state.allTypes.length > 0) {
            return
        }

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {
                this.setState({ allTables: response.data.tables, allTypes: response.data.types })
            }
        }).catch(() => {
            this.setState({ allTables: [], allTypes: [] })
        })

    }

    /* Tables Of The Search */
    getTables = () => {

        /* Fields */
        const { allTables, search } = this.state
        const value = search.trim().toLowerCase()

        /* Check Search */
        if (value === "") {
            return allTables
        }

        /* Send Result */
        return allTables.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()
            const studio = String(utils.checkValue(item.studioName, "")).toLowerCase()

            return name.includes(value) || slug.includes(value) || studio.includes(value)
        })
    }

    /* Check Table */
    checkTable = (table) => {
        return this.state.tables.findIndex((item) => item.slug === table.slug) > -1
    }

    /* Toggle Table — by the slug, that is what the game servers write */
    toggleTable = (table) => {

        /* Fields */
        const { tables } = this.state

        /* Get Index */
        const index = tables.findIndex((item) => item.slug === table.slug)

        /* Check Index */
        if (index > -1) {
            tables.splice(index, 1)
        }
        else {
            tables.push(table)
        }

        this.setState({ tables })
    }

    /* Select Every Table Of The Search — an empty selection already means every table */
    selectAll = () => {
        this.setState({ tables: [...this.getTables()] })
    }

    /* Deselect Every Table */
    deselectAll = () => {
        this.setState({ tables: [] })
    }

    /* Select Period */
    select = (selected) => {

        /* All Period — no border goes to the request */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
            return
        }

        /* Hours */
        const hours = { "3hours": 3, "6hours": 6, "12hours": 12 }

        if (hours[selected]) {
            this.setState({ start: nowInTz().subtract(hours[selected], "hours").toDate(), end: nowInTz().toDate(), selected })
            return
        }

        /* Today */
        if (selected === "today") {
            this.setState({ start: nowInTz().startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* Yesterday */
        if (selected === "yesterday") {
            this.setState({
                start: nowInTz().subtract(1, "day").startOf("day").toDate(),
                end: nowInTz().subtract(1, "day").endOf("day").toDate(),
                selected,
            })
            return
        }

        /* Days */
        const days = { "7days": 6, "14days": 13, "30days": 29 }

        if (days[selected] !== undefined) {
            this.setState({ start: nowInTz().subtract(days[selected], "days").startOf("day").toDate(), end: nowInTz().endOf("day").toDate(), selected })
            return
        }

        /* This Month */
        if (selected === "month") {
            this.setState({ start: nowInTz().startOf("month").toDate(), end: nowInTz().endOf("month").toDate(), selected })
            return
        }

        /* Previous Month */
        if (selected === "prevmonth") {
            this.setState({
                start: nowInTz().subtract(1, "month").startOf("month").toDate(),
                end: nowInTz().subtract(1, "month").endOf("month").toDate(),
                selected,
            })
        }

    }

    /* Reset Action */
    reset = () => {
        this.setState({ selected: "all", start: null, end: null, tables: [], type: "", search: "" })
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, tables, type } = this.state
        const { apply } = this.props

        /* Check Dates */
        if (selected !== "all" && (!start || !end)) {
            Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
            return
        }

        /* Set Apply */
        apply({ selected, start, end, tables, type })

        /* Close Modal */
        this.close()
    }

    /* Draw Period */
    _period = () => {

        /* Fields */
        const { selected, start, end } = this.state

        return (
            <div className="log--section">

                <div className="log--section-head">
                    <div className="log--section-title">
                        <CalendarIcon />
                        {t("log.period")}
                    </div>
                </div>

                <div className="log--chips">
                    {this.getPeriods().map((item, index) =>
                        <div
                            onClick={() => this.select(item.key)}
                            className={`log--chip ${selected === item.key ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.text}
                        </div>
                    )}
                </div>

                <div className="log--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.setState({ start: date, selected: "period" })}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        maxDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("log.dateFrom")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date, selected: "period" })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        placeholderText={t("log.dateTo")}
                    />

                </div>

            </div>
        )
    }

    /* Draw Types — the column is a plain string, only what the logs really contain is offered */
    _types = () => {

        /* Fields */
        const { allTypes, type } = this.state

        /* Check Types */
        if (allTypes.length < 2) {
            return null
        }

        return (
            <div className="log--section">

                <div className="log--section-head">
                    <div className="log--section-title">
                        <FilterIcon size={13} />
                        {t("log.type")}
                    </div>
                </div>

                <div className="log--chips">

                    <div onClick={() => this.setState({ type: "" })} className={`log--chip ${type === "" ? "active" : ""}`}>
                        {t("log.allTypes")}
                    </div>

                    {allTypes.map((item, index) =>
                        <div
                            onClick={() => this.setState({ type: item.type })}
                            className={`log--chip ${type === item.type ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item.type}
                            <span className="log--chip-count">{item.count}</span>
                        </div>
                    )}

                </div>

            </div>
        )
    }

    /* Draw Tables */
    _tables = () => {

        /* Fields */
        const { allTables, tables, search } = this.state
        const list = this.getTables()

        return (
            <div className="log--section">

                <div className="log--section-head">

                    <div className="log--section-title">
                        <TableIcon />
                        {t("log.games")}
                        <span className={`log--counter ${tables.length === 0 ? "empty" : ""}`}>{tables.length}</span>
                    </div>

                    <div className="log--section-actions">
                        <span onClick={() => this.selectAll()}>{t("filter.selectAll")}</span>
                        <span onClick={() => this.deselectAll()}>{t("filter.deselectAll")}</span>
                    </div>

                </div>

                {allTables.length > SEARCHABLE &&
                    <div className="log--inner-search">
                        <SearchIcon size={14} />
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("log.searchByGame")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="log--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {list.length === 0 &&
                    <div className="log--chips-empty">{search !== "" ? t("log.nothingFound") : t("log.gamesEmpty")}</div>
                }

                <div className="log--tables">
                    {list.map((item, index) =>
                        <div
                            onClick={() => this.toggleTable(item)}
                            className={`log--table-chip ${this.checkTable(item) ? "active" : ""}`}
                            key={`${index}`}
                        >

                            <div className="log--table-box">{this.checkTable(item) && <CheckIcon size={11} />}</div>

                            <div className="log--table-text">
                                <div className="log--table-name">{utils.checkValue(item.name, item.slug)}</div>
                                <div className="log--table-note">{item.slug}</div>
                            </div>

                            <div className="log--table-count">{item.count}</div>

                        </div>
                    )}
                </div>

                <div className="log--hint">
                    <InfoIcon />
                    <span>{t("log.gamesHint")}</span>
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="log--modal"
                overlayClassName="log--overlay"
                closeTimeoutMS={200}
            >

                <div className="log--modal-header">

                    <div className="log--modal-icon">
                        <FilterIcon size={18} />
                    </div>

                    <div className="log--modal-head-text">
                        <h2>{t("log.filterTitle")}</h2>
                        <p>{t("log.filterSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="log--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="log--modal-body">

                    {/* Draw Period */}
                    {this._period()}

                    {/* Draw Types */}
                    {this._types()}

                    {/* Draw Tables */}
                    {this._tables()}

                </div>

                <div className="log--modal-footer space">

                    <div onClick={() => this.reset()} className="log--button ghost">{t("log.reset")}</div>

                    <div className="log--modal-footer-right">
                        <div onClick={() => this.close()} className="log--button ghost">{t("filter.cancel")}</div>
                        <div onClick={() => this.apply()} className="log--button primary">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(LogFilter)
